import { EC2Client } from "@aws-sdk/client-ec2";
import { fromWebToken } from "@aws-sdk/credential-providers";
import { getDefaultRoleAssumerWithWebIdentity } from "@aws-sdk/client-sts";
import { getAuthToken } from "../../functions/getAuthToken";
import { getSpotPricesByInstanceType } from "../../functions/getSpotPricesByInstanceType";

export const getInstanceDrillDownData = async (instanceType: string) => {
  const { Token, IdentityId } = await getAuthToken();

  const ec2Client = new EC2Client({
    region: "eu-west-1",
    credentials: fromWebToken({
      roleArn:
        "arn:aws:iam::573586820653:role/service-role/RegionPriceCompareAnonRole",
      webIdentityToken: Token,
      roleSessionName: IdentityId.substring(IdentityId.indexOf(":") + 1),
      roleAssumerWithWebIdentity: getDefaultRoleAssumerWithWebIdentity(),
    }),
  });

  return getSpotPricesByInstanceType(ec2Client, instanceType);
};
